import React, { useState } from 'react';
import { LoginForm } from '../components/LoginForm';
import { TotpForm } from '../components/TotpForm';
import { OtpForm } from '../components/OtpForm';

type LoginMode = 'password' | 'totp' | 'otp';

export function Login() {
  const [mode, setMode] = useState<LoginMode>('password');
  const [adminId, setAdminId] = useState<string>('');
  const [username, setUsername] = useState<string>('');

  const handleSwitchToTotp = (id: string) => {
    setAdminId(id);
    setMode('totp');
  };

  const handleSwitchToOtp = (user: string) => {
    setUsername(user);
    setMode('otp');
  };

  const handleBackToPassword = () => {
    setMode('password');
    setAdminId('');
    setUsername('');
  };

  const handleSuccess = () => {
    // Redirect will be handled by the auth context or router
    window.location.href = '/admin/dashboard';
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="card card-outline card-primary">
          <div className="card-header text-center">
            <h1 className="h4 mb-0">TALKwAI Admin</h1>
          </div>
          <div className="card-body">
            {mode === 'password' && (
              <LoginForm
                onSwitchToTotp={handleSwitchToTotp}
                onSwitchToOtp={handleSwitchToOtp}
                onSuccess={handleSuccess}
              />
            )}
            {mode === 'totp' && (
              <TotpForm
                adminId={adminId}
                onSuccess={handleSuccess}
                onBack={handleBackToPassword}
              />
            )}
            {mode === 'otp' && (
              <OtpForm
                username={username}
                onSuccess={handleSuccess}
                onBack={handleBackToPassword}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
